import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IResultVerify, IUser, UserModel } from "../../models/user.model";
import { environment } from '../../../../../environments/environment';
import { AuthModel, IAuth } from "../../models/auth.model";
import {IOTPModel} from "../../models/otp.model";
import {IModuleModel} from "../../../../models/security/module.model";
import {IResultInvitations, ResultInvitations} from "../../../../models/security/create-user.model";
import { IJoinRequestPayload } from "../../../../models/security/join-request.model";
import {map} from "rxjs/operators";
import * as CryptoJS from 'crypto-js';
const API_AUTH_URL = `${environment.apiAuthUrl}/auth`;
const API_SECURITY_URL = `${environment.apiAuthUrl}/security`;
const API_EMAIL_INVIATION_URL = `${environment.apiUrl}/orders/get_email_invitation/`;


@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(private http: HttpClient) {}

  // public methods
  login(email: string, password: string, token:string): Observable<IOTPModel> {
    return this.http.post<IOTPModel>(`${API_AUTH_URL}/login/`, {
      email,
      password,
      token
    });
  }

  getEmailInvitation(email: string): Observable<IResultInvitations> {
    const body = { email: email };
    return this.http.post<IResultInvitations>(API_EMAIL_INVIATION_URL, body);
  }

  logout(): Observable<any> {
    const body = {
    };

    return this.http.post(`${API_AUTH_URL}/logout/`, body);
  }

  // CREATE =>  POST: add a new user to the server
  createUser(user: UserModel): Observable<UserModel> {
    return this.http.post<UserModel>(API_AUTH_URL, user);
  }

  registration(first_name: string,last_name: string, password: string, password2: string, email: string) {
    let body = JSON.stringify({
      first_name: first_name,
      last_name: last_name,
      email: email,
      password1: password,
      password2: password2

    });
    return this.http.post<UserModel>(`${API_AUTH_URL}/registration/`, body);
  }

  getMenus(practiceId:string): Observable<IModuleModel[]> {
    return this.http.get<IModuleModel[]>(`${environment.apiUrl}/security/user_menus/?practice_id=${practiceId}?/&practice_id=${practiceId}` );
  }

  verifyMail(key: string): Observable<any> {
    let body = JSON.stringify({
      key: key
    });
    return this.http.post<UserModel>(`${API_AUTH_URL}/confirm-email/`, body);
  }

  verifyUsernameExist(key: string): Observable<IResultVerify> {
    let body = JSON.stringify({
      key: key
    });
    return this.http.post<IResultVerify>(`${API_AUTH_URL}/verify_username/`, body);
  }

  verifyEmailExist(key: string): Observable<IResultVerify> {
    let body = JSON.stringify({
      key: key
    });
    return this.http.post<IResultVerify>(`${API_AUTH_URL}/verify_mail/`, body);
  }

  getUserMenus(): Observable<any> {
    return this.http.get(`${API_SECURITY_URL}/user_menus/`);
  }

  // Your server should check email => If email exists send link to the user and return true | If email doesn't exist return false
  forgotPassword(email: string): Observable<any> {
    return this.http.post<any>(`${API_AUTH_URL}/password/reset/`, {
      email,
    });
  }

  forgotPasswordConfirm(token: string, new_password1: string, new_password2: string,otp:string): Observable<any> {
    return this.http.post(`${API_AUTH_URL}/password/reset/confirm/`, {
      token,
      new_password1,
      new_password2,
      otp
    });
  }

  getUserByToken(token: string): Observable<IUser> {
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'x-app-key': environment.appKey
    });
    return this.http.get<IUser>(`${API_AUTH_URL}/user/`, {
      headers: httpHeaders,
    });
  }

  changePassword(new_password1: string, new_password2: string, oldPassword: string): Observable<any> {
    let body = JSON.stringify({
      new_password1: new_password1,
      new_password2: new_password2,
      old_password: oldPassword
    });
    return this.http.post(`${API_AUTH_URL}/password/change/`, body);
  }

  verifyToken(token: string): Observable<any> {
    let body = JSON.stringify({
      token: token
    });
    return this.http.post(`${API_AUTH_URL}/verify/`, body);
  }

  refreshToken(token: string): Observable<any> {
    return this.http.post(`${API_AUTH_URL}/token/refresh/`, {refresh:token});
  }

  resendVerificationCode(email: string): Observable<any> {
    return this.http.post(`${API_AUTH_URL}/verification_code/`, {
      email,
    });
  }

  verifyCode(token: string): Observable<any> {
    return this.http.get(`${API_AUTH_URL}/verification_code/`, {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'x-app-key': environment.appKey
      })
    });
  }

  resendVerificationCodeWithOptions(token: string, otpDeliveryOptions: any): Observable<any> {
    const apiUrl = `${API_AUTH_URL}/resend_verification_code/`;

    // Construir el cuerpo de la solicitud según las opciones proporcionadas
    const body = {
      token: token,
      ...otpDeliveryOptions
    };

    // Realizar la solicitud HTTP, puedes usar HttpClient de Angular aquí
    return this.http.post(apiUrl, body);
  }

  requestVerificationCode(token: string, otp: string, login_method:string ): Observable<IAuth> {
    return this.http.post<IAuth>(`${API_AUTH_URL}/verification_code/`, {
      token,
      otp,
      login_method
    });
  }

  // Público a nivel de usuario; el interceptor agrega Content-Type y x-app-key.
  generateJoinRequest(payload: IJoinRequestPayload): Observable<any> {
    return this.http.post(`${environment.apiUrl}/orders/generate_join_request/`, payload);
  }
}
